'use strict';
'use es6';
/* eslint react/jsx-handler-names: 0 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _underscore = require('../utils/underscore');

var _ActiveElement = require('../core/ActiveElement');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _Selectors = require('../constants/Selectors');

var _UIControlledPopover = require('./UIControlledPopover');

var _UIControlledPopover2 = _interopRequireDefault(_UIControlledPopover);

var _UITooltipContent = require('./UITooltipContent');

var _UITooltipContent2 = _interopRequireDefault(_UITooltipContent);

var _UITooltipHeader = require('./UITooltipHeader');

var _UITooltipHeader2 = _interopRequireDefault(_UITooltipHeader);

var _PlacementConstants = require('./PlacementConstants');

var _Hover = require('./utils/Hover');

var _Functions = require('../core/Functions');

var _focusStylesListener = require('../listeners/focusStylesListener');

var _Memoize = require('../core/Memoize');

var _SafePureComponent2 = require('../core/SafePureComponent');

var _SafePureComponent3 = _interopRequireDefault(_SafePureComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var USE_CLASSES = {
  default: 'tooltip-default private-tooltip--default',
  danger: 'tooltip-danger private-tooltip--danger',
  longform: 'private-tooltip--longform'
};

var instanceCount = 0;

var allTooltips = [];

var getStyle = function getStyle(style, maxWidth) {
  return _extends({}, style, { maxWidth: maxWidth });
};

var setOpen = function setOpen(component, newOpen) {
  if (!component._isMounted) return;
  if (newOpen && component.props.disabled) return;
  if (newOpen === component.props.open) return;
  component.props.onOpenChange((0, _SyntheticEvent2.default)(newOpen));
};

var getDelayedSetOpen = function getDelayedSetOpen(component, delay) {
  var boundSetOpen = (0, _underscore.partial)(setOpen, component);
  return delay === 0 ? boundSetOpen : function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return setTimeout(function () {
      return boundSetOpen.apply(undefined, args);
    }, delay);
  };
};

var UITooltip = function (_SafePureComponent) {
  _inherits(UITooltip, _SafePureComponent);

  function UITooltip(props) {
    _classCallCheck(this, UITooltip);

    var _this = _possibleConstructorReturn(this, (UITooltip.__proto__ || Object.getPrototypeOf(UITooltip)).call(this, props));

    _this.state = {
      listeningForMouseMove: false
    };

    instanceCount += 1;
    _this._tooltipId = 'uiTooltip-' + instanceCount;

    _this._getStyle = (0, _Memoize.memoizeLastResult)(getStyle);
    _this._setOpen = getDelayedSetOpen(_this, props.delay);
    _this.refCallback = _this.refCallback.bind(_this);
    _this.triggerClose = _this.triggerClose.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
    _this.handleBodyMouseMove = _this.handleBodyMouseMove.bind(_this);
    _this.handlePopoverFocusLeave = _this.handlePopoverFocusLeave.bind(_this);
    _this.renderContent = _this.renderContent.bind(_this);
    return _this;
  }

  _createClass(UITooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var open = this.props.open;

      allTooltips.push(this);
      this._isMounted = true;
      if (open) {
        this.startIntersectionObserver();
        this.addBodyMouseListeners();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var delay = _ref.delay;

      if (delay !== this.props.delay) {
        this._setOpen = getDelayedSetOpen(this, delay);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var open = this.props.open;

      if (!prevProps.open && open) {
        this.startIntersectionObserver();
        this.addBodyMouseListeners();
        allTooltips.forEach(function (tooltip) {
          if (tooltip === _this2) return;
          if (tooltip._isMounted) {
            setOpen(tooltip, false);
          }
        });
      } else if (prevProps.open && !open) {
        this.stopIntersectionObserver();
        this.removeBodyMouseListeners();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      allTooltips.splice(allTooltips.indexOf(this), 1);
      this._isMounted = false;
      this.stopIntersectionObserver();
      this.removeBodyMouseListeners();
    }
  }, {
    key: 'startIntersectionObserver',
    value: function startIntersectionObserver() {
      var _this3 = this;

      // We use Intersection Observer to try to close the tooltip if its target
      // ceases to be visible to the user, e.g. due to scrolling (issue #1412).
      var _window = window,
          IntersectionObserver = _window.IntersectionObserver;

      if (!IntersectionObserver) return; // No browser support; oh well.

      var targetEl = (0, _reactDom.findDOMNode)(this._ref);
      if (!targetEl) return;

      // eslint-disable-next-line compat/compat
      this._intersectionObserver = new IntersectionObserver(function (entries) {
        var intersectionRatio = entries[0].intersectionRatio;

        if (intersectionRatio <= 0) setOpen(_this3, false);
      });
      this._intersectionObserver.observe(targetEl);
    }
  }, {
    key: 'stopIntersectionObserver',
    value: function stopIntersectionObserver() {
      if (this._intersectionObserver) {
        this._intersectionObserver.disconnect();
        this._intersectionObserver = null;
      }
    }
  }, {
    key: 'refCallback',
    value: function refCallback(ref) {
      this._ref = ref;
    }
  }, {
    key: 'addBodyMouseListeners',
    value: function addBodyMouseListeners() {
      if (!document.body) return;
      document.body.addEventListener('mouseleave', this.triggerClose);
      document.body.addEventListener('mousemove', this.handleBodyMouseMove);
    }
  }, {
    key: 'removeBodyMouseListeners',
    value: function removeBodyMouseListeners() {
      if (!document.body) return;
      document.body.removeEventListener('mouseleave', this.triggerClose);
      document.body.removeEventListener('mousemove', this.handleBodyMouseMove);
    }
  }, {
    key: 'triggerClose',
    value: function triggerClose() {
      var onClose = this.props.onClose;

      setOpen(this, false);
      this._closeOnPopoverFocusLeave = false;
      (0, _Functions.callIfPossible)(onClose);
      this.setState({
        listeningForMouseMove: false
      });
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(evt) {
      // Very special-case, but important for a11y: When we tab out of the tooltip
      // target, the focus moves to the first tabbable element inside of the
      // tooltip (if any). When that happens, we need to prevent the tooltip from
      // closing when the target blur event fires and instead close it when the
      // focus leaves the tooltip content.
      var key = evt.key,
          shiftKey = evt.shiftKey;

      if (key === 'Tab' && !shiftKey) {
        var tooltipEl = document.getElementById(this._tooltipId);
        if (!tooltipEl) {
          return;
        }
        if (tooltipEl.querySelector(_Selectors.FOCUSABLE)) {
          this._closeOnPopoverFocusLeave = true;
        }
      }
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur() {
      if (this._closeOnPopoverFocusLeave || !this._wasOpenedByFocus) {
        return;
      }
      var targetEl = (0, _reactDom.findDOMNode)(this._ref);
      if (targetEl && targetEl.contains((0, _ActiveElement.getActiveElement)())) {
        // If blur has occurred but document.activeElement still points to the
        // anchor element, it means the entire document has lost focus. See
        // HubSpot/UIComponents#784
        return;
      }
      this.triggerClose();
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus() {
      if (!(0, _focusStylesListener.isPageInKeyboardMode)()) return;
      this._wasOpenedByFocus = true;
      setOpen(this, true);
    }
  }, {
    key: 'handlePopoverFocusLeave',
    value: function handlePopoverFocusLeave() {
      if (this._closeOnPopoverFocusLeave) {
        this._closeOnPopoverFocusLeave = false;
        this.triggerClose();
      }
    }
  }, {
    key: 'handleMouseEnter',
    value: function handleMouseEnter() {
      var _this4 = this;

      // Workaround for React bug that allows handleMouseEnter to be called twice
      // for the same event (rare but possible!)
      if (this._holdTimeout) {
        return;
      }

      var delayOnHold = this.props.delayOnHold;

      this._openTimeout = this._setOpen(true);
      this._closeOnPopoverFocusLeave = false;
      this._holdTimeout = setTimeout(function () {
        setOpen(_this4, true);
      }, delayOnHold);
      this._wasOpenedByFocus = false;
      this.setState({
        listeningForMouseMove: true
      });
    }
  }, {
    key: 'handleMouseLeave',
    value: function handleMouseLeave() {
      // If open has been triggered but a delay is in effect, cancel open.
      clearTimeout(this._openTimeout);
      this._openTimeout = null;
      clearTimeout(this._holdTimeout);
      this._holdTimeout = null;

      var _props = this.props,
          disabled = _props.disabled,
          open = _props.open;


      if (disabled) {
        this.triggerClose();
      }

      // If we're open, we need to keep listening to mousemove until the mouse has left the bounds of
      // the tooltip itself. Otherwise, we don't need the listener.
      this.setState({
        listeningForMouseMove: open
      });
    }
  }, {
    key: 'handleBodyMouseMove',
    value: function handleBodyMouseMove(evt) {
      var _this5 = this;

      if (!this._isMounted) return;

      var _props2 = this.props,
          delayOnHold = _props2.delayOnHold,
          open = _props2.open;

      if (open) {
        // Bail early and often if the target and/or tooltip aren't in the DOM
        var targetEl = (0, _reactDom.findDOMNode)(this._ref);
        if (!targetEl) return;
        var tooltipEl = document.getElementById(this._tooltipId);
        if (!tooltipEl) return;

        var tooltipArea = tooltipEl.getBoundingClientRect();
        var targetArea = targetEl.getBoundingClientRect();

        if ((0, _Hover.shouldTooltipClose)(targetArea, tooltipArea, evt)) {
          this.triggerClose();
        }
      } else if (this._holdTimeout) {
        clearTimeout(this._holdTimeout);
        this._holdTimeout = setTimeout(function () {
          setOpen(_this5, true);
        }, delayOnHold);
      }
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var _props3 = this.props,
          innerClassName = _props3.innerClassName,
          headingText = _props3.headingText,
          title = _props3.title,
          use = _props3.use;

      return _react2.default.createElement(
        _UITooltipContent2.default,
        {
          className: (0, _classNames2.default)(innerClassName, 'tooltip-inner', {
            'has--vertical-spacing': use === 'longform'
          })
        },
        headingText != null ? _react2.default.createElement(
          _UITooltipHeader2.default,
          {
            className: (0, _classNames2.default)({
              'private-tooltip--longform__heading': use === 'longform'
            })
          },
          headingText
        ) : null,
        title
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          autoPlacement = _props4.autoPlacement,
          _bodyElement = _props4._bodyElement,
          className = _props4.className,
          Content = _props4.Content,
          disabled = _props4.disabled,
          __headingText = _props4.headingText,
          __innerClassName = _props4.innerClassName,
          maxWidth = _props4.maxWidth,
          __onClose = _props4.onClose,
          onOpenChange = _props4.onOpenChange,
          open = _props4.open,
          placement = _props4.placement,
          style = _props4.style,
          title = _props4.title,
          use = _props4.use;


      var computedClassName = (0, _classNames2.default)(className, USE_CLASSES[use], 'tooltip', 'private-tooltip', 'tooltip-' + use + '-border', 'private-tooltip--' + use + '__border');

      var computedDisabled = disabled || Content == null && title == null;
      var computedOpen = open && !computedDisabled;

      var child = _react.Children.only(this.props.children);
      var clonedChild = (0, _react.cloneElement)(child, {
        'aria-describedby': computedOpen ? this._tooltipId : undefined,
        onBlur: (0, _Functions.memoizedSequence)(this.handleBlur, child.props.onBlur),
        onFocus: (0, _Functions.memoizedSequence)(this.handleFocus, child.props.onFocus),
        onKeyDown: (0, _Functions.memoizedSequence)(this.handleKeyDown, child.props.onKeyDown),
        onMouseEnter: (0, _Functions.memoizedSequence)(this.handleMouseEnter, child.props.onMouseEnter),
        onMouseLeave: (0, _Functions.memoizedSequence)(this.handleMouseLeave, child.props.onMouseLeave),
        tabIndex: computedDisabled ? child.props.tabIndex : 0 // #4949
      });

      return _react2.default.createElement(
        _UIControlledPopover2.default,
        {
          arrowSize: use === 'longform' ? 'medium' : 'small',
          autoPlacement: autoPlacement,
          _bodyElement: _bodyElement,
          className: computedClassName,
          Content: Content || this.renderContent,
          closeOnOutsideClick: true,
          id: this._tooltipId,
          onFocusLeave: this.handlePopoverFocusLeave,
          onOpenChange: onOpenChange,
          open: computedOpen,
          placement: placement,
          ref: this.refCallback,
          style: this._getStyle(style, maxWidth),
          use: 'unstyled'
        },
        clonedChild
      );
    }
  }]);

  return UITooltip;
}(_SafePureComponent3.default);

UITooltip.propTypes = {
  autoPlacement: _react.PropTypes.bool,
  children: _react.PropTypes.node,
  className: _react.PropTypes.string,
  Content: _UIControlledPopover2.default.propTypes.Content,
  delay: _react.PropTypes.number.isRequired,
  delayOnHold: _react.PropTypes.number.isRequired,
  disabled: _react.PropTypes.bool.isRequired,
  headingText: _react.PropTypes.node,
  innerClassName: _react.PropTypes.string,
  maxWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  onClose: _react.PropTypes.func,
  onOpenChange: _react.PropTypes.func.isRequired,
  open: _react.PropTypes.bool.isRequired,
  placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
  style: _react.PropTypes.object,
  title: _react.PropTypes.node,
  use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES)),
  _bodyElement: _react.PropTypes.instanceOf(HTMLElement)
};

UITooltip.defaultProps = {
  autoPlacement: true,
  delay: 300,
  delayOnHold: 100,
  disabled: false,
  open: false,
  placement: 'top',
  use: 'default'
};

exports.default = (0, _Controllable2.default)(UITooltip, ['open']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/tooltip/UITooltip.js
// module id = 53
// module chunks = 2 3